var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRebateCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 21.8333,
    height: 21.8333,
    rx: 10.9167
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7754 7.39844C16.3065 6.86734 17.1681 6.86734 17.6992 7.39844C18.2301 7.92946 18.23 8.79022 17.6992 9.32129L11.2031 15.8174C11.1269 15.8936 11.043 15.9574 10.9551 16.0117C10.9332 16.037 10.9117 16.0629 10.8877 16.0869C10.3566 16.618 9.49497 16.618 8.96387 16.0869L5.59863 12.7217C5.06753 12.1906 5.06753 11.329 5.59863 10.7979C6.12963 10.2671 6.99044 10.2672 7.52148 10.7979L9.94824 13.2246L15.7754 7.39844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebateCheckmark);
export default __webpack_public_path__ + "static/media/rebate-checkmark.6182b1e76539cbe6a5ac4b07c6920778.svg";
export { ForwardRef as ReactComponent };